import React from "react";
import { Link } from "react-router-dom";

interface Instructor {
  title: string;
  thumbnail_url?: string;
}

interface CourseItemProps {
  title: string;
  imageUrl: string;
  instructor: Instructor;
  rating: number;
  progress: number;
  lessonsCount: number;
  duration: string;
  category: string;
  courseLink: string;
  instructorLink: string;
}

const CourseItem: React.FC<CourseItemProps> = ({
  title,
  imageUrl,
  instructor,
  rating,
  progress,
  lessonsCount,
  duration,
  category,
  courseLink,
  instructorLink,
}) => {
  return (
    <div className="col">
      <div className="courses__item courses__item-two shine__animate-item">
        <div className="courses__item-thumb courses__item-thumb-two">
          <a href={courseLink} className="shine__animate-link">
            <img src={imageUrl} alt={title} />
          </a>
        </div>
        <div className="courses__item-content courses__item-content-two">
          <ul className="courses__item-meta list-wrap">
            <li className="courses__item-tag">
              <button className="link-button">{category}</button>
            </li>
          </ul>
          <h5 className="title">
            <Link to={courseLink}>{title}</Link>
          </h5>
          <div className="courses__item-content-bottom">
            <div className="author-two">
              <Link to={instructorLink}>
                <img src={instructor?.thumbnail_url} alt={instructor.title} />
                {instructor.title}
              </Link>
            </div>
          </div>
          <div className="avg-rating" style={{ marginTop: "16px" }}>
            <i className="fas fa-star"></i> ({rating} Reviews)
          </div>
          <div className="progress-item progress-item-two">
            <h6 className="title">
              COMPLETE <span>{progress}%</span>
            </h6>
            <div
              className="progress"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
            >
              <div
                className="progress-bar"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        </div>
        <div className="courses__item-bottom-two">
          <ul className="list-wrap">
            <li>
              <i className="flaticon-book"></i>
              {lessonsCount}
            </li>
            <li>
              <i className="flaticon-clock"></i>
              {duration}
            </li>
            {/* <li>
              <i className="flaticon-mortarboard"></i>0
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CourseItem;
